module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("blXXC"))).then(() => module.bundle.root('f4eak'));